<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48">
    <title>{{title}}</title>
    <g :fill="color">
      <path
        d="M38 38H10V10h14V6H10c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V24h-4v14zM28 6v4h7.17L15.51 29.66l2.83 2.83L38 12.83V20h4V6H28z"></path>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: "Open In New"
      },
      color: {
        type: String,
        default: "currentColor",
      },
      size: {
        type: Number,
        default: 48,
      },
    },
    name: "OpenInNew",
  }
</script>
